import React from 'react';
import { ArrowRightIcon, ClockIcon, MapPinIcon } from 'lucide-react';
import { events } from '../data/homepage';
export function Events() {
  return <section aria-labelledby="evenements-titre" className="bg-ville-mist py-20" data-id="element-1531" data-mp="2c6vuatetc9f3">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10" data-id="element-1532" data-mp="2h08jb4nemi8d">
        <div className="flex flex-wrap items-end justify-between gap-4" data-id="element-1533" data-mp="2lzbbhoiactyx">
          <div data-id="element-1534" data-mp="1p8iumonj2xw3">
            <p className="text-sm font-bold uppercase tracking-wider text-ville-blue" data-id="element-1535" data-mp="1p8soinbp1p72">Calendrier</p>
            <h2 id="evenements-titre" className="mt-2 text-4xl font-extrabold tracking-tight text-ville-navy lg:text-5xl" data-id="element-1536" data-mp="1t9kvtb109k0p">
              Prochains événements
            </h2>
          </div>
          <a href="#accueil" className="inline-flex items-center gap-2 text-base font-bold text-ville-deep transition-colors duration-150 ease-ville hover:text-ville-blue" data-id="element-1537" data-mp="2393elo56izr6">
            Voir le calendrier complet
            <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-1538" data-mp="2jt2bh8l8gcnm" />
          </a>
        </div>

        <ul className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-1539" data-mp="2jqptivfh62ak">
          {events.map(event => <li key={event.id} className="flex" data-id="element-1540" data-mp="2asdzskjbaodw">
              <a href="#accueil" className="group flex w-full flex-col rounded-3xl bg-white p-6 transition-transform duration-150 ease-ville hover:-translate-y-1 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-blue" data-id="element-1541" data-mp="2aqt24m1papbt">
                <div className="flex items-start justify-between" data-id="element-1542" data-mp="1w2f1mhrrbcyf">
                  <div className="rounded-2xl bg-ville-navy px-4 py-3 text-center text-white" data-id="element-1543" data-mp="1s1mr7l75f20k">
                    <span className="block text-2xl font-extrabold leading-none" data-id="element-1544" data-mp="1n2rwbkvwpn03">{event.day}</span>
                    <span className="mt-1 block text-[11px] font-bold tracking-wider" data-id="element-1545" data-mp="1i3p1et9n4x5u">{event.month}</span>
                  </div>
                  <span className="rounded-full bg-ville-mist px-3 py-1 text-xs font-bold text-ville-deep" data-id="element-1546" data-mp="1d4c9hu3wwzwe">
                    {event.tag}
                  </span>
                </div>
                <h3 className="mt-5 text-lg font-bold leading-snug text-ville-navy transition-colors duration-150 ease-ville group-hover:text-ville-blue" data-id="element-1547" data-mp="18gmagnk9vc1x">
                  {event.title}
                </h3>
                <div className="mt-auto space-y-1.5 pt-5 text-sm text-slate-600" data-id="element-1548" data-mp="yh55y9grb47j">
                  <p className="flex items-center gap-2" data-id="element-1549" data-mp="1m7r8xmbwlyao">
                    <MapPinIcon className="h-4 w-4 text-ville-blue" aria-hidden="true" data-id="element-1550" data-mp="1m89e58gjnmuq" />
                    {event.place}
                  </p>
                  <p className="flex items-center gap-2" data-id="element-1551" data-mp="1dfpgaa82tmay">
                    <ClockIcon className="h-4 w-4 text-ville-blue" aria-hidden="true" data-id="element-1552" data-mp="1dd36e3xpqupk" />
                    {event.time}
                  </p>
                </div>
              </a>
            </li>)}
        </ul>
      </div>
    </section>;
}